module.exports = __webpack_public_path__ + "static/the-curse-of-the-mogul-473783436412b017e388516c282b1abf.jpg";